<template>
    <div class="row" v-on:mousemove="checkInactivityMoveMouse">
        <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
            <header-servico
                v-if="is_morph == false"
                tipo="Encaminhamento"
                :loading="loading"
                :familia="familia.id"
            />
        </template>
        <load v-if="loading" message="Carregando os dados do Encaminhamento" />
        <div v-else class="col-md-12">
            <!--Tabela-->
            <div class="row">
                <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
                    <sidebar-servicos
                        active="encaminhamento"
                        :familia="familia"
                        v-if="is_morph == false"
                    />
                </template>
                <ModalVerificarPrivado
                    :familia-id="familia.id"
                    v-if="encaminhamento.privado == 1 && status_privado == false"
                    @liberar="status_privado = true"
                />
                <div :class="(is_morph || encaminhamento.acolhimento_idosos_id != null || encaminhamento.acolhimento_crianca_id != null) ? 'col-md-12' : 'col-md-9'" v-on:mousemove="status_privado = !checkInactivity">
                    <div class="row">
                        <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
                            <div class="col-md-12" v-if="is_morph == false">
                                <header-familia :item="familia" />
                            </div>
                        </template>
                    </div>
                    <div class="card mb-0 shadow" v-if="historicoStatus == false">
                        <div class="card-body">
                            <div class="tab-content">
                                <div class="animate__animated animate__fadeIn">
                                    <div class="row">
                                        <div class="col-12">
                                            <h4 class="font-weight-bold">
                                                Gestão de Encaminhamento
                                            </h4>
                                        </div>

                                        <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
                                            <div
                                                class="col-md-12"
                                                v-if="
                                                    encaminhamento.agendamentos &&
                                                    encaminhamento.agendamentos
                                                        .length > 0
                                                "
                                            >
                                                <div class="alert alert-info">
                                                    <span
                                                        v-if="
                                                            encaminhamento
                                                                .agendamentos
                                                                .length == 1
                                                        "
                                                        >Existe
                                                        {{
                                                            encaminhamento
                                                                .agendamentos.length
                                                        }}
                                                        solicitação de
                                                        agendamento.</span
                                                    >
                                                    <span
                                                        v-else-if="
                                                            encaminhamento
                                                                .agendamentos
                                                                .length > 1
                                                        "
                                                        >Existem
                                                        {{
                                                            encaminhamento
                                                                .agendamentos.length
                                                        }}
                                                        solicitações de
                                                        agendamentos.</span
                                                    >

                                                    <a
                                                        class="router-link-exact-active active d-block"
                                                        @click="
                                                            solicitacoesAgendamentos = true
                                                        "
                                                        href="#agendamentos"
                                                    >
                                                        <i
                                                            class="mdi mdi-calendar-clock"
                                                        ></i>
                                                        Mais detalhes
                                                    </a>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="col-12">
                                            <table class="table table-bordered bg-white table-sm">
                                                <tbody>
                                                    <tr>
                                                        <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
                                                            <td colspan="2">
                                                                Usuário(s) Atendidos:
                                                                <b class="badge badge-light mr-2" v-for="pessoa in encaminhamento.pessoas_objetos" :key="pessoa.id">
                                                                    {{ pessoa.nome_completo }}
                                                                </b>
                                                            </td>
                                                        </template>
                                                        <template v-else>
                                                            <td colspan="2">
                                                                Usuário(s) Atendidos:
                                                                <b class="badge badge-light mr-2" v-for="pessoa in encaminhamento.pessoas_acolhimento" :key="pessoa.id">
                                                                    <b>
                                                                        <!-- Exibe nome social se houver -->
                                                                        {{ pessoa.nome_acolhido || pessoa.nome  }}
                                                                    </b>
                                                                </b>
                                                            </td>
                                                        </template>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            ID:<b>{{
                                                                encaminhamento.id
                                                            }}</b>
                                                            Protocolo:<b>{{
                                                                encaminhamento.protocolo
                                                            }}</b>
                                                        </td>
                                                        <td>
                                                            Criado:<b>{{
                                                                encaminhamento.cadastrado
                                                            }}</b>
                                                            Atualizado:<b>{{
                                                                encaminhamento.atualizado
                                                            }}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">
                                                            Técnico autor:
                                                            <b>{{ encaminhamento.autor }}</b>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Técnico
                                                            responsável: <b
                                                                v-if="
                                                                    encaminhamento.responsavel
                                                                "
                                                                >{{
                                                                    encaminhamento
                                                                        .responsavel
                                                                        .nome
                                                                }}</b
                                                            > - <span> {{ encaminhamento.responsavel.profissao ?? 'Não informado' }} </span>
                                                        </td>
                                                        <td>
                                                            Unidade de Origem:
                                                            <b
                                                                v-if="
                                                                    encaminhamento.unidade
                                                                "
                                                                >{{
                                                                    encaminhamento
                                                                        .unidade
                                                                        .nome
                                                                }}</b
                                                            >
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Destinatário: <b
                                                                v-if="encaminhamento.destino"
                                                                >{{
                                                                    encaminhamento
                                                                        .destino
                                                                        .nome
                                                                }}</b
                                                            > <span v-if="encaminhamento.destino" > - {{ encaminhamento.destino.profissao ?? 'Não informado' }} </span>
                                                        </td>
                                                        <td>
                                                            Unidade de Destino:
                                                            <b
                                                                v-if="
                                                                    encaminhamento.unidade_destino
                                                                "
                                                                >{{
                                                                    encaminhamento
                                                                        .unidade_destino
                                                                        .nome
                                                                }}</b
                                                            >
                                                            <span
                                                                v-if="
                                                                    encaminhamento.unidade_externa
                                                                "
                                                                class="text-muted text-xs"
                                                            >
                                                                - Unidade
                                                                Externa
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr class="table-secondary">
                                                        <td colspan="2">
                                                            Tipo de
                                                            Encaminhamento:
                                                            <b>{{
                                                                encaminhamento.tipo
                                                            }}</b>
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            encaminhamento.relacao !=
                                                                null &&
                                                            $route.meta
                                                                .controller !=
                                                                encaminhamento
                                                                    .relacao
                                                                    .controller
                                                        "
                                                    >
                                                        <td
                                                            colspan="2"
                                                            v-if="
                                                                encaminhamento.relacao
                                                            "
                                                        >
                                                            <span
                                                                class="small"
                                                                v-html="
                                                                    encaminhamento
                                                                        .relacao
                                                                        .mensagem
                                                                "
                                                            ></span>
                                                            <router-link
                                                                :title="
                                                                    $t(
                                                                        'Ver Acompanhamento'
                                                                    )
                                                                "
                                                                :to="
                                                                    encaminhamento
                                                                        .relacao
                                                                        .link
                                                                "
                                                                type="a"
                                                            >
                                                                <strong>
                                                                    Ver</strong
                                                                >
                                                            </router-link>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <form-textarea-editor
                                            v-model="encaminhamento.descricao"
                                            label="Descrição sumária do Encaminhamento"
                                            :required="true"
                                        />
                                        <form-select
                                            @change="verificarStatus"
                                            v-model="encaminhamento.status"
                                            label="Status"
                                            grid="4"
                                            :itens="status"
                                            :ajuda="ajuda_status"
                                        />
                                        <form-file
                                            grid="8"
                                            @submit="submitFile"
                                            multiple
                                            btn-text="Iniciar"
                                            :progress="progressCompleted"
                                        />
                                    </div>
                                    <div class="row pt-4 px-0 d-flex justify-content-end">

                                        <form-toggle
                                            grid="3"
                                            mt="0"
                                            v-model="encaminhamento.privado"
                                            label="Sigilo?"
                                        />

                                        <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
                                            <a
                                                class="router-link-exact-active active px-3"
                                                @click="
                                                    solicitacoesAgendamentos = true
                                                "
                                            >
                                                <i
                                                    class="mdi mdi-calendar-clock"
                                                ></i>
                                                Solicitação de Agendamento
                                            </a>
                                        </template>

                                        <a
                                            class="router-link-exact-active active px-3"
                                            @click="historicoStatus = true"
                                        >
                                            <i class="fas fa-history"></i>
                                            Histórico de Status
                                        </a>

                                    </div>
                                    <div
                                        class="row pt-4 px-0 d-flex justify-content-end"
                                    >
                                        
                                        <div class="col-auto px-2 text-right">
                                            <a
                                                v-if="veioDoAcolhimento"
                                                class="btn btn-default mr-1"
                                                title="Voltar para o acolhimento"
                                                @click="voltarParaAcolhimento"
                                                v-b-tooltip.hover
                                            >
                                                <i class="mdi mdi-arrow-left" />
                                                {{ $t("Voltar") }}
                                            </a>

                                            <a
                                                v-if="is_morph"
                                                class="btn btn-default"
                                                @click="$emit('voltar')"
                                            >
                                                <i class="mdi mdi-arrow-left" />
                                            </a>
                                            <a
                                                class="btn btn-primary"
                                                @click="$bvModal.show('modal-auditoria')"
                                                :title="$t('Auditoria')"
                                                v-b-tooltip.hover
                                            >
                                                <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                                            </a>
                                            <a
                                                v-if="
                                                $store.state.user.role_details.name == 'Admin' ||
                                                $store.state.user.role_details.name == 'Gestor(a)' ||
                                                $store.state.user.id == encaminhamento.user_id
                                                "
                                                title="Remanejar"
                                                class="btn btn-warning py-2"
                                                @click="$bvModal.show('modal-remanejar-servico')"
                                            >
                                                <i class="fas fa-exchange-alt mdi-18px" />
                                                {{ $t("Remanejar") }}
                                            </a>
                                            <b-button
                                                :title="
                                                    $t('Visualizar e Imprimir')
                                                "
                                                :to="
                                                    '/dashboard/encaminhamentos/show/' +
                                                    encaminhamento.id
                                                "
                                                class="py-1"
                                                size="sm"
                                                type="button"
                                                v-b-tooltip.hover
                                                variant="primary"
                                            >
                                                <i
                                                    class="mdi mdi-printer mdi-18px"
                                                />
                                            </b-button>
                                            <button
                                                class="btn btn-success btn-submit"
                                                data-style="zoom-in"
                                                type="submit"
                                                @click="submit"
                                            >
                                                <i
                                                    class="mdi mdi-content-save"
                                                />
                                                {{ $t("Salvar") }}
                                            </button>
                                        </div>
                                    </div>

                                    <template v-if="encaminhamento.acolhimento_idosos_id == null && encaminhamento.acolhimento_crianca_id == null">
                                        <!-- Área de Solicitações de Agendamentos -->
                                        <div
                                            class="col-md-12"
                                            v-if="solicitacoesAgendamentos"
                                            id="agendamentos"
                                        >
                                            <Agendamentos
                                                :agendamentos="
                                                    encaminhamento.agendamentos
                                                "
                                                @voltar="
                                                    solicitacoesAgendamentos = false
                                                "
                                                @reload="
                                                    getEncaminhamento(),
                                                        (solicitacoesAgendamentos = true)
                                                "
                                            />
                                        </div>
                                    </template>

                                    <div v-if="historicos">
                                        <h4>
                                            <i class="mdi mdi-reply"></i>
                                            Resposta
                                        </h4>
                                        <table
                                            class="table table-bordered bg-white table-sm"
                                            v-for="historico in historicos"
                                            :key="historico.id"
                                        >
                                            <tr>
                                                <td>
                                                    Técnico:
                                                    <b>{{
                                                        historico.user_id
                                                    }}</b>
                                                </td>
                                                <td>
                                                    Data manual da ação:{{
                                                        historico.data_atualizacao
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td
                                                    colspan="2"
                                                    v-if="historico.motivo"
                                                >
                                                    Motivo:
                                                    <b>{{
                                                        historico.motivo
                                                            .descricao
                                                    }}</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">
                                                    <p>
                                                        <b
                                                            >Descrição da
                                                            Resposta</b
                                                        >
                                                    </p>
                                                    {{ historico.observacoes }}
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <anexos :anexos="encaminhamento.anexos" />
                                    <modulo-comentario
                                        module="Encaminhamento"
                                        :id="encaminhamento.id"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-0 shadow card-body" v-else>
                        <div class="tab-content">
                            <div class="animate__animated animate__fadeIn">
                                <div class="row">
                                    <div class="col-12">
                                        <h4 class="font-weight-bold">
                                            Registro de Encaminhamento
                                        </h4>
                                    </div>
                                    <Header :item="encaminhamento" />
                                    <HistoricoStatus
                                        @voltar="historicoStatus = false"
                                        :id="encaminhamento.id"
                                        :familia="encaminhamento?.familia_id || 0"
                                        :status="status_item"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalRemanejarServico
            servico="encaminhamentos"
            :servico_id="encaminhamento.id"
            :tecnico_id="encaminhamento.responsavel.id"
        />
        <status-historico
            :model="model"
            modulo="Encaminhamento"
            titulo_modulo="ENCAMINHAMENTOS"
            :id="encaminhamento.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_item"
            @submit="submit"
        />
        <ModalAuditoria
            servico="encaminhamentos"
            :servico_id="encaminhamento.id"
        />
    </div>
</template>
<script>
import ModalRemanejarServico from "../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import HistoricoStatus from "./HistoricoStatus";
import Agendamentos from "./includes/SolictacoesAgendamento";
import Header from "./Header";
import ModalAuditoria from '../../../../../resources/js/dashboard/components/widgets/ModalAuditoria';
export default {
    name: "Edit",
    props: ["morph", "morphEncaminhamentoId", "morph_type"],
    components: {
        HistoricoStatus,
        Agendamentos,
        Header,
        ModalVerificarPrivado,
        ModalRemanejarServico,
        ModalAuditoria 
    },
    data() {
        return {
            encaminhamento: { responsavel: {} },
            tecnicos: {},
            files: {},
            status: {},
            status_item: [],
            statusAtual: "",
            statusAnterior: "",
            historicoStatus: false,
            familia: {},
            loading: true,
            progressCompleted: 0,
            is_morph: false,
            model: "Encaminhamento",
            historicos: {},
            status_privado: false,
            solicitacoesAgendamentos: false,
            ajuda_status:`<b>ENCAMINHADO:</b> O status Encaminhado é indicado sempre que o usuário da Plataforma, registra um encaminhamento no sistema, e ainda não realizou a gestão desse encaminhamento;<br><br>
            <b>RESPONDIDO:</b> O status Respondido é indicado sempre que o usuário da Plataforma, realiza a gestão de um Encaminhamento e ao atualizar para respondido aponta os motivos para tal, que pode ser: superação da problemática; não solucionado; ou que o encaminhamento está em acompanhamento;<br><br>
            <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar um encaminhamento realizado, atualiza o status para finalizado informando os motivos pelo qual está encerrando a intervenção. Os motivos podem ser: retorno para cidade de origem (recambio), não adesão ao serviço; mudança de endereço (referenciamento); mudança de cidade; óbito, encaminhamento concluído, e outros motivos que culminaram na finalização do encaminhamento.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`
        };
    },
    computed: {
        filterResposta() {
            let tempRecipes = this.historicos;

            tempRecipes = tempRecipes.filter((item) => {
                return item.status == 2;
            });

            return tempRecipes;
        },
        checkInactivity() {
            if (this.$root.isIdle == true) {
                this.status_privado = false;
                this.$bvModal.show("verificar-encaminhamento-privado");
            }
            return this.$root.isIdle;
        },
        veioDoAcolhimento() {
            const idIdoso = this.encaminhamento?.acolhimento_idosos_id;
            const idCrianca = this.encaminhamento?.acolhimento_crianca_id;

            return (
                (idIdoso !== null && idIdoso !== undefined && idIdoso !== "") ||
                (idCrianca !== null && idCrianca !== undefined && idCrianca !== "")
            );
        },
    },
    mounted() {
        this.morph ? (this.is_morph = true) : (this.is_morph = false);
        this.getStatus();
        this.getTecnicos();
        this.getEncaminhamento();
        this.getHistorico();
        this.getStatusFinais();
    },
    methods: {
        voltarParaAcolhimento() {
            this.$router.go(-1);
        },
        checkInactivityMoveMouse() {
            if (this.encaminhamento.privado == 1) {
                if (this.$root.isIdle == true) {
                    this.status_privado = false;
                    this.$bvModal.show("verificar-encaminhamento-privado");
                }
                return this.$root.isIdle;
            } else {
                return false;
            }
        },
        getEncaminhamento() {
            this.loading = true;
            var id = this.is_morph
                ? this.morphEncaminhamentoId
                : this.$route.params.id;
            axios
                .get(`api/dashboard/encaminhamentos/${id}`)
                .then((response) => {
                    if (
                        response.data.data.user_id != this.$store.state.user.id
                    ) {
                        swal.fire({
                            title: "Acesso Negado!",
                            html: "Pressione OK para continuar.",
                            icon: "error",
                        });

                        this.$router.push(
                            "/dashboard/encaminhamentos/show/" +
                                response.data.data.id
                        );
                    }

                    this.encaminhamento = response.data.data;
                    this.familia = this.encaminhamento.familia_formatado || 0;
                    this.$route.query.familia_id =
                        this.encaminhamento.familia_id.id || 0;
                    this.statusAnterior = this.encaminhamento.status;
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        submitFile(files) {
            this.files = files;
        },
        getTecnicos() {
            axios.get(`api/dashboard/tecnicos/get`).then((response) => {
                this.tecnicos = response.data;
            });
        },
        getStatus() {
            axios
                .get(`api/dashboard/status/encaminhamentos`)
                .then((response) => {
                    this.status = response.data;
                });
        },
        verificarStatus(status) {
            this.statusAtual = status;

            const result = this.status_item.filter((item) => item.id == status);
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: "Encaminhamento",
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        getHistorico() {
            var id = this.is_morph
                ? this.morphEncaminhamentoId
                : this.$route.params.id;

            axios
                .get("api/dashboard/encaminhamentos/historico/status/" + id)
                .then((response) => {
                    this.historicos = response.data;
                })
                .catch(() => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "Histórico d Status não foi carregado corretamente<br>" +
                            error,
                        icon: "error",
                    });
                });
        },
        submit() {

            this.encaminhamento.familia_id = this.familia.id;

            if (this.encaminhamento.data_prevista != "") {
                this.encaminhamento.data_prevista = moment(
                    this.encaminhamento.data_prevista,
                    "YYYY-MM-DD H:mm"
                ).format("DD/MM/YYYY");
            }

            let formData = new FormData();

            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("files[]", this.files[i]);
                }
            } else {
                formData.append("files", this.files);
            }

            for (var key in this.encaminhamento) {
                formData.append(key, this.encaminhamento[key]);
            }
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/update/encaminhamento`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.encaminhamento = response.data.data;
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                    this.getEncaminhamento();
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
